import { useCallback, useContext } from 'react';

import { UpsellModalProps } from '../components/UpsellModal';
import { ModalContextDispatch } from '../containers/ModalsContext/UpsellModalContext';

export const useUpsellModal = () => {
  const { setModalContextState } = useContext(ModalContextDispatch);

  if (!setModalContextState) {
    throw new Error('useUpsellModal must be used within a Upsell Modal Provider');
  }

  return {
    close: useCallback(
      () => setModalContextState({ isActive: false, state: null }),
      [setModalContextState],
    ),
    open: useCallback(
      (state: UpsellModalProps) => {
        setModalContextState({ isActive: true, state });
      },
      [setModalContextState],
    ),
  };
};
